import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/3dots.svg'
import _imports_1 from '@/assets/img/like_full.png'
import _imports_2 from '@/assets/img/like_empty.png'
import _imports_3 from '@/assets/img/management/comment.svg'
import _imports_4 from '@/assets/img/received.svg'
import _imports_5 from '@/assets/img/share.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-357c186b")

_pushScopeId("data-v-357c186b")
const _hoisted_1 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "postCreator" }
const _hoisted_3 = {
  key: 0,
  class: "publishDate mb-1 orange"
}
const _hoisted_4 = { class: "fs_13 d-block ln_12 name" }
const _hoisted_5 = { class: "publishDate" }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = {
  class: "postText",
  ref: "postText"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" [..")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("..] ")
const _hoisted_10 = {
  key: 0,
  class: "postAttachment"
}
const _hoisted_11 = {
  key: 2,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_12 = {
  key: 0,
  src: _imports_1,
  class: "me-1"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_2,
  class: "me-1"
}
const _hoisted_14 = { class: "fs_10 greyBlue" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "me-1"
}, null, -1)
const _hoisted_16 = { class: "fs_10 greyBlue" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "me-1"
}, null, -1)
const _hoisted_18 = { class: "fs_10 greyBlue" }
const _hoisted_19 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_user_profile_image = _resolveComponent("user-profile-image")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_share_button = _resolveComponent("share-button")!

  return (_openBlock(), _createBlock("div", {
    class: ["postContainer", { 'postBlock': _ctx.isBlock }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_user_profile_image, {
          class: "creatorImage",
          src: _ctx.$store.state.getUserImage(_ctx.post.creator.identifier),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openPerson(_ctx.post.creator)))
        }, null, 8, ["src"]),
        _createVNode("div", {
          class: ["creatorInfo", _ctx.showCommunityTitle ? 'pointer':''],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openPostInCommunity()))
        }, [
          (_ctx.showCommunityTitle)
            ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.post.communityTitle), 1))
            : _createCommentVNode("", true),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.post.creator.name), 1),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$filters.date(_ctx.post.publishedDate)) + " - " + _toDisplayString(_ctx.$filters.time(_ctx.post.publishedDate)), 1)
        ], 2)
      ]),
      (_ctx.loggedUser && _ctx.loggedUser.identifier && !_ctx.onlyView)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            src: _imports_0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPostOptionsModal()))
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("span", {
          innerHTML: _ctx.post.text
        }, null, 8, ["innerHTML"])
      ], 512),
      _createVNode("div", {
        class: "postShowMore",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAll()))
      }, [
        _hoisted_8,
        _createVNode(_component_localized_text, {
          localizedKey: 'app_mostratutto',
          text: 'Mostra tutto'
        }),
        _hoisted_9
      ])
    ]),
    (_ctx.post.attachmentUrl)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          (_ctx.post.mimeType.indexOf('image') > -1)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "postImage",
                style: 'background-image: url(\'' + _ctx.post.preview + '\');'
              }, null, 4))
            : (_ctx.post.mimeType.indexOf('video') > -1)
              ? (_openBlock(), _createBlock("video", {
                  key: 1,
                  class: "postVideo",
                  controls: "",
                  controlsList: _ctx.openExternalAttachment ? 'nodownload' : ''
                }, [
                  _createVNode("source", {
                    src: _ctx.post.attachmentUrl,
                    type: _ctx.post.mimeType
                  }, null, 8, ["src", "type"])
                ], 8, ["controlsList"]))
              : (_ctx.post.mimeType.indexOf('audio') > -1)
                ? (_openBlock(), _createBlock("audio", {
                    key: 2,
                    class: "postAudio",
                    controls: "",
                    controlsList: _ctx.openExternalAttachment ? 'nodownload' : ''
                  }, [
                    _createVNode("source", {
                      src: _ctx.post.attachmentUrl,
                      type: "audio/mpeg"
                    }, null, 8, ["src"])
                  ], 8, ["controlsList"]))
                : (_ctx.post.mimeType.indexOf('pdf') > -1)
                  ? (_openBlock(), _createBlock("div", {
                      key: 3,
                      class: "postImage pdf",
                      style: 'background-image: url(\'' + _ctx.$filters.previewFix('/img/icon_pdf.svg') + '\')'
                    }, null, 4))
                  : (_ctx.post.mimeType.indexOf('application/vnd.ms-powerpoint') > -1 || _ctx.post.mimeType.indexOf('application/vnd.openxmlformats-officedocument.presentationml.presentation') > -1)
                    ? (_openBlock(), _createBlock("div", {
                        key: 4,
                        class: "postImage ppt",
                        style: 'background-image: url(\'' + _ctx.$filters.previewFix('/img/icon_ppt.svg') + '\')'
                      }, null, 4))
                    : (_ctx.post.mimeType.indexOf('application/vnd.ms-excel') > -1 || _ctx.post.mimeType.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') > -1)
                      ? (_openBlock(), _createBlock("div", {
                          key: 5,
                          class: "postImage xls",
                          style: 'background-image: url(\'' + _ctx.$filters.previewFix('/img/xls.png') + '\')'
                        }, null, 4))
                      : (_ctx.post.mimeType.indexOf('application/vnd.openxmlformats-officedocument.wordprocessingml.document') > -1 || _ctx.post.mimeType.indexOf('application/msword') > -1)
                        ? (_openBlock(), _createBlock("div", {
                            key: 6,
                            class: "postImage xls",
                            style: 'background-image: url(\'' + _ctx.$filters.previewFix('/img/icon_word.svg') + '\')'
                          }, null, 4))
                        : _createCommentVNode("", true)
        ]))
      : (_ctx.youtubeLink)
        ? (_openBlock(), _createBlock("iframe", {
            key: 1,
            src: _ctx.youtubeLink,
            style: {"width":"90%","margin-left":"5%","height":"200px"},
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          }, "\r\n        ", 8, ["src"]))
        : _createCommentVNode("", true),
    (_ctx.showActions && (_ctx.loggedUser && _ctx.loggedUser.identifier))
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", {
            class: "d-flex align-items-center",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doLike()))
          }, [
            (_ctx.post.liked)
              ? (_openBlock(), _createBlock("img", _hoisted_12))
              : (_openBlock(), _createBlock("img", _hoisted_13)),
            _createVNode("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.post.likes.length) + " ", 1),
              (!_ctx.openExternalAttachment)
                ? (_openBlock(), _createBlock(_component_localized_text, {
                    key: 0,
                    localizedKey: "app_mipiace",
                    text: "mi piace",
                    class: "fs_10 greyBlue text-capitalize"
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", {
            class: "d-flex align-items-center",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openComments()))
          }, [
            _hoisted_15,
            _createVNode("span", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.post.commentNumber) + " ", 1),
              (!_ctx.openExternalAttachment)
                ? (_openBlock(), _createBlock(_component_localized_text, {
                    key: 0,
                    localizedKey: "app_commenti",
                    text: "commenti",
                    class: "fs_10 greyBlue text-capitalize"
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.openExternalAttachment)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "d-flex align-items-center",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openAttachment()))
              }, [
                _hoisted_17,
                _createVNode("span", _hoisted_18, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_apri",
                    text: "apri",
                    class: "fs_10 greyBlue text-capitalize"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.shareUrl)
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode(_component_share_button, { shareUrl: _ctx.shareUrl }, {
                  default: _withId(() => [
                    _hoisted_20,
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_condividi",
                      text: "condividi",
                      class: "'fs_10 greyBlue text-capitalize'"
                    })
                  ]),
                  _: 1
                }, 8, ["shareUrl"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
})